import {
  Text,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Tooltip,
} from "@chakra-ui/react";
import { IoMdSearch } from "react-icons/io";
import React from "react";

const SearchBox = ({ onSearch }) => {
  return (
    <HStack>
      <Text fontSize={"14px"}>Search : </Text>
      <Tooltip label="Search by topic name" placement="top" hasArrow>
        <InputGroup flex={1} size="xs">
          <InputLeftElement pointerEvents="none">
            <IoMdSearch color="gray" />
          </InputLeftElement>
          <Input
            flex={1}
            placeholder="Search..."
            onChange={(e) => onSearch(e.target.value)}
          />
        </InputGroup>
      </Tooltip>
    </HStack>
  );
};

export default SearchBox;
